module.exports = __webpack_public_path__ + "assets/img/en-eaa9bca9.png";